import React, { useState, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import clsx from 'clsx';

import NoMatch from './StatusErrors/NoMatch';
import OfflineMessage from './StatusErrors/OfflineMessage';

import Sidebar from './sidebar';
import Header from './header';
import Notification from './Notification';
import WelcomeDialog from './WelcomeDialog';
import PaginationNavBar from './PaginationNavBar';
import EmailVerificationDialog from '../content/SettingsTabs/EmailVerificationDialog';
import DynamicBreadcrumb from './DynamicBreadcrumb';
import CompanyCreate from '../content/CompanyCreate';

const Content = ({ routes, notification, isCollapsed, setIsCollapsed, selectedCompany, isWelcomeDialogVisible, setIsWelcomeDialogVisible, isDialogVisible, setIsDialogVisible }) => {
    const location = useLocation();
    const currentRoute = routes.find(route => new RegExp(`^${route.path.replace(/:[^\s/]+/g, '[^/]+')}$`).test(location.pathname));
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const [logoLoaded, setLogoLoaded] = useState(false);
    const [hideLogoLoading, setHideLogoLoading] = useState(false);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        const logoLoadedTimeout = setTimeout(() => {
            setLogoLoaded(true);
        }, 300);

        const hideLogoLoadingTimeout = setTimeout(() => {
            setHideLogoLoading(true);
        }, 1000);

        return () => {
            clearTimeout(logoLoadedTimeout);
            clearTimeout(hideLogoLoadingTimeout);
        };
    }, []);

    return (
        <>

            <div className={clsx('logo-loading-container', { 'loaded': logoLoaded })} style={
                !hideLogoLoading ? {
                    zIndex: 2147483647,
                    position: 'fixed',
                    width: '100vw',
                    height: '100vh',
                } : { display: 'none' }}>
                <img src="/images/svg/logo-deepsy-svg.svg" alt="DeePsy Logo" />
            </div>

            {notification && <Notification notification={notification} setIsDialogVisible={setIsDialogVisible} />}

            <Header hasNotification={!!notification} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

            {currentRoute?.showPaginationNavBar && <PaginationNavBar isCollapsed={isCollapsed} notification={notification} />}

            <div className={clsx('main-content')}>
                <Sidebar
                    hasNotification={!!notification}
                    isDisabled={!isOnline || !selectedCompany}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                />

                <div className={clsx('content', { 'with-pagination': currentRoute?.showPaginationNavBar, 'has-notification': !!notification })}>
                    {isOnline ? (
                        selectedCompany ? (
                            <>
                                {routes.some(route => route.path === currentRoute?.path) && <DynamicBreadcrumb routes={routes} />}
                                <Switch>
                                    {routes.map((route, i) => (
                                        <Route key={i} exact path={route.path} component={route.component} />
                                    ))}
                                    <Route component={NoMatch} />
                                </Switch>
                            </>
                        ) : (
                            <Route component={CompanyCreate} />
                        )
                    ) : (
                        <OfflineMessage />
                    )}

                    <WelcomeDialog isVisible={isWelcomeDialogVisible} onClose={() => setIsWelcomeDialogVisible(false)} />
                </div>
            </div>

            {isDialogVisible && <EmailVerificationDialog visible={isDialogVisible} onHide={() => setIsDialogVisible(false)} />}
        </>
    );
};

export default Content;